import { Header } from '../../../../components/common/table/Header/Header';
import { HeaderCell } from '../../../../components/common/table/HeaderCell/HeaderCell';
import '../List.scss';

export interface ListHeaderProps {}

export function ListHeader() {
  return (
    <Header>
      <HeaderCell>{`collimator `}</HeaderCell>
      <HeaderCell>{`machine data `}</HeaderCell>
      <HeaderCell>{`date  (HH:MM:SS) `}</HeaderCell>
      <HeaderCell className="details-column">Actions</HeaderCell>
    </Header>
  );
}
